// extracted by mini-css-extract-plugin
module.exports = {"title":"CustomerLogosSection_title__AejIp","image":"CustomerLogosSection_image__zsd3r"};